import React from "react";

export default function InputNormal({ title }) {
  const mgTop = {
    marginTop:"10px"
  }
  return (
    <div style={mgTop}>
      <p className="txt-sub-explanation1" >{title}</p>
      <input className="text-field" placeholder={title} style={mgTop} />
    </div>
  );
}
